module.exports = __webpack_public_path__ + "img/noPeopleInLight.1aba0246.png";